module.exports = __webpack_public_path__ + "img/orderBg.cb53af09.jpg";